var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCross = function SvgCross(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52228 11.3587L1.00759 2.84398L3.12891 0.722656L11.6436 9.23735L9.52228 11.3587Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52228 11.3587L1.00759 2.84398L3.12891 0.722656L11.6436 9.23735L9.52228 11.3587Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2805 2.84491L2.76585 11.3596L0.644531 9.23828L9.15922 0.723588L11.2805 2.84491Z",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2805 2.84491L2.76585 11.3596L0.644531 9.23828L9.15922 0.723588L11.2805 2.84491Z",
    fill: "#FF0000"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCross);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjUyMjI4IDExLjM1ODdMMS4wMDc1OSAyLjg0Mzk4TDMuMTI4OTEgMC43MjI2NTZMMTEuNjQzNiA5LjIzNzM1TDkuNTIyMjggMTEuMzU4N1oiIGZpbGw9IiNGRjAwMDAiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjUyMjI4IDExLjM1ODdMMS4wMDc1OSAyLjg0Mzk4TDMuMTI4OTEgMC43MjI2NTZMMTEuNjQzNiA5LjIzNzM1TDkuNTIyMjggMTEuMzU4N1oiIGZpbGw9IiNGRjAwMDAiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS4yODA1IDIuODQ0OTFMMi43NjU4NSAxMS4zNTk2TDAuNjQ0NTMxIDkuMjM4MjhMOS4xNTkyMiAwLjcyMzU4OEwxMS4yODA1IDIuODQ0OTFaIiBmaWxsPSIjRkYwMDAwIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTEuMjgwNSAyLjg0NDkxTDIuNzY1ODUgMTEuMzU5NkwwLjY0NDUzMSA5LjIzODI4TDkuMTU5MjIgMC43MjM1ODhMMTEuMjgwNSAyLjg0NDkxWiIgZmlsbD0iI0ZGMDAwMCIvPgo8L3N2Zz4K";